<template>
  <t-layout :showNav="false">
    <div class="page">
      <div class="status">
        <img
          class="icon"
          src="https://wz-s1.makingdreams101.cn/wanzhuan_mp/activity/points-lottery/status-icon.png"
        />
        <div class="text">兑换成功</div>
      </div>

      <div class="list" v-if="!!payInfo">
        <div class="item">
          <div class="label">订单号</div>
          <div class="value">{{ payInfo.goodOrderId }}</div>
        </div>
        <div class="item">
          <div class="label">扣减移动积分</div>
          <div class="value">{{ payInfo.points }}积分</div>
        </div>
        <div class="item">
          <div class="label">兑换畅由积分</div>
          <div class="value">{{ payInfo.cyPoints }}积分</div>
        </div>
        <div class="item">
          <div class="label">畅由积分消费权益内容</div>
          <div class="value">{{ payInfo.goodsName }}</div>
        </div>
      </div>

      <div class="action">
        <div class="btn" @click="toList">完成</div>
      </div>
    </div>
  </t-layout>
</template>

<script>
export default {
  name: 'activityLotteryResult',
  components: {},
  data() {
    return {
      payInfo: null
    }
  },
  created() {
    const options = this.$route.query

    if (options.payInfo) {
      const payInfo = decodeURIComponent(options.payInfo || '')
      this.payInfo = JSON.parse(payInfo)
    }
  },

  mounted() {},

  activated() {
    this.$store.commit('setTitle', '兑换成功')
  },

  methods: {
    toList() {
      this.$router.replace({
        path: `/activity/lottery/list`
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  color: #2e2e2e;
  background: #fff;
  padding-bottom: 32rpx;
  min-height: 100vh;
}

.status {
  padding: 80rpx 0 112rpx;

  .icon {
    width: 332rpx;
    height: 244rpx;
    display: block;
    margin: 0 auto 16rpx;
  }
  .text {
    text-align: center;
    font-size: 34rpx;
    line-height: 34rpx;
    font-weight: 500rpx;
  }
}

.list {
  padding: 0 80rpx;
  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 24rpx;
    line-height: 24rpx;
    margin-bottom: 24rpx;

    .value {
      color: #999999;
    }
  }
}

.action {
  margin-top: 128rpx;
  .btn {
    margin: 0 auto;
    width: 492rpx;
    height: 92rpx;
    line-height: 92rpx;
    color: #fff;
    text-align: center;
    text-shadow: 0 2rpx 6rpx #d41021;
    font-size: 30rpx;
    font-weight: 500;
    background-image: url('https://wz-s1.makingdreams101.cn/wanzhuan_mp/activity/points-lottery/bg-btn.png');
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
}
</style>
